import { Jersey } from '@/ui/components';

interface TeamJerseyProps {
  jerseySrc: string;
  teamName: string;
}

const TeamJersey = ({ jerseySrc, teamName }: TeamJerseyProps) => (
  <div className="relative flex h-[95px] w-[95px] justify-center">
    <Jersey jerseySrc={jerseySrc} size={95} withOverlay />
    <div className="absolute bottom-0 left-0 right-0 flex flex-col items-center justify-end">
      <span className="text-center line-clamp-2 font-robotoMedium font-medium text-[14px] leading-[18px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark">
        {teamName}
      </span>
    </div>
  </div>
);

export default TeamJersey;
